/** Renders an empty box **/
export var BOX_ICON = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    pathData: ['M0,0 h24 v24 h-24 v-20 h4 v16 h16 v-16 h-20 z'],
};
/** Renders nothing **/
export var EMPTY_ICON = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    pathData: [],
};
/** Renders a question mark **/
export var QUESTION_MARK_ICON = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    pathData: ['M6,0 h12 v12 h-4 v4 h-4 v-8 h4 v-4 h-8 z M10,20 h4 v4 h-4 z'],
};
export var FAKE_TEST_WARNING_ICON = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    pathData: ['Unit tests detected - icons will not be fetched. To force fetching, initialize PaperIconCache with { unitTestMode: false }']
};
export var LOADING_ICON = EMPTY_ICON;
export var ERROR_ICON = BOX_ICON;
//# sourceMappingURL=fallbackIcons.js.map